module.exports = __webpack_public_path__ + "img/loading_copy.984381ca.gif";